import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Button,
  useMediaQuery,
  Slider,
  Tooltip,
} from "@mui/material";
import bg from "../images/profit-bg.png";
import Progress from "./Progress";
import { makeStyles } from "@mui/styles";
import { useStakingContract, useStakingContract1 } from "../hooks";
import {
  formatUnits,
  parseUnits,
  formatEther,
  parseEther,
  commify,
} from "@ethersproject/units";
import { toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Loading from "../loading";
import Web3 from "web3";
import { defaulatAddress } from "../utils/environment";
import { HashLink } from "react-router-hash-link";
const web3 = new Web3(
  Web3.givenProvider ? Web3.givenProvider : "https://bsc-dataseed.binance.org/"
);

function ValueLabelComponent(props) {
  const { children, value } = props;
  return (
    <Tooltip
      enterTouchDelay={0}
      placement="top"
      title={value}
      sx={{ color: "white" }}
    >
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const iOSBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const marks = [
  {
    value: 7,
  },
  {
    value: 8,
  },
  {
    value: 9,
  },
  {
    value: 10,
  },
  {
    value: 11,
  },
  {
    value: 12,
  },
  {
    value: 13,
  },
  {
    value: 14,
  },
  {
    value: 15,
  },
  {
    value: 16,
  },
  {
    value: 17,
  },
  {
    value: 18,
  },
  {
    value: 19,
  },
  {
    value: 20,
  },
  {
    value: 21,
  },
  {
    value: 22,
  },
  {
    value: 23,
  },
  {
    value: 24,
  },
  {
    value: 25,
  },
  {
    value: 26,
  },
  {
    value: 27,
  },
  {
    value: 28,
  },

  {
    value: 29,
  },
  {
    value: 30,
  },
];

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: "#EEBE62",
  height: 16,
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    height: 19,
    width: 19,
    backgroundColor: "#fff",
    boxShadow: iOSBoxShadow,
    "&:focus, &:hover, &.Mui-active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 12,
    fontWeight: "normal",
    top: -6,
    backgroundColor: "white",
    color: "white",
    "&:before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: theme.palette.mode === "dark" ? "#fff" : "#000",
    },
  },
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    paddingLeft: "10px",
  },
  "& .MuiSlider-mark": {
    backgroundColor: "#EEBE62",
    height: 10,
    width: 1,
    "&.MuiSlider-markActive": {
      opacity: 1,
      backgroundColor: "currentColor",
    },
  },
}));

const useStyles = makeStyles({
  label: {
    fontSize: "18px",
    fontWeight: 400,
  },
  value: {
    fontSize: "36px",
    fontWeight: 700,
  },
});
function CalculateProfit() {
  const classes = useStyles();
  const matches = useMediaQuery("(max-width:750px)");
  const { account } = useWeb3React();
  const stakingContract = useStakingContract();
  const stakingContract1 = useStakingContract1();

  const [loading, setloading] = useState(false);
  const [stakingAmount, setstakingAmount] = useState(1);
  const [planIndex, setplanIndex] = useState(0);
  const [progressValue, setprogressValue] = useState(7);
  const [bonusPercentage, setbonusPercentage] = useState(0);
  const [bonus, setbonus] = useState(0);
  const [dailyBonus, setdailyBonus] = useState(0);
  const [walletBalance, setwalletBalance] = useState(0);

  const init = async () => {
    try {
      const planBonusValue = await stakingContract1.methods
        .getStakePlanInfo(parseUnits(stakingAmount.toString()), +planIndex)
        .call();
      setbonusPercentage(planBonusValue[0]);
      setbonus(formatUnits(planBonusValue[1]));
      setdailyBonus(formatUnits(planBonusValue[2]));
      // console.log(
      //   formatUnits(planBonusValue[1]),
      //   "formatUnits(planBonusValue[1])"
      // );
    } catch (error) {
      console.log("Error==>", error);
    }
  };

  useEffect(async () => {
    if (window.location.href.includes("?ref=")) {
      let getAddress = window.location.href.split("?ref=")[1];
      let final = getAddress.slice(0, 42);
      localStorage.setItem("BNB_SHIELD", final);
    }
    if (account) {
      const balance = await web3.eth.getBalance(account);
      setwalletBalance(formatUnits(balance));
    }
    if (progressValue && stakingAmount) {
      init();
    }
  }, [progressValue, stakingAmount]);
  let refAddress = localStorage.getItem("BNB_SHIELD");
  const stakeHadler = async () => {
    if (account) {
      if (!stakingAmount) {
        toast.error("Error! Please enter amount");
      } else if (isNaN(+stakingAmount) || +stakingAmount < 0) {
        toast.error("Error! Please enter a valid amount");
      } else if (+stakingAmount < 0.1) {
        toast.error("Error! Minimun amount to stake is 0.1BNB.");
      } else if (+stakingAmount > 1000) {
        toast.error("Error! Maximum amount to stake is 1000BNB.");
      } else {
        try {
          setloading(true);
          const reffaddress = refAddress ? refAddress : defaulatAddress;
          // console.log(reffaddress, "reffaddress =====>");
          const tx = await stakingContract.stake(reffaddress, planIndex, {
            value: parseUnits(stakingAmount.toString()),
          });
          await tx.wait();
          toast.success("Success! Transaction confirmed.");
          setloading(false);
          // init();
        } catch (error) {
          if (error?.data?.message) {
            toast.error(error?.data?.message);
          } else {
            toast.error(error?.message);
          }
          setloading(false);
        }
      }
    } else {
      toast.error("Error! Please connect your wallet.");
    }
  };

  return (
    <Box
      id="deposit"
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      mt={{ xs: 0, sm: 10 }}
      pb={10}
    >
      <Loading loading={loading} />
      <Container maxWidth="lg">
        <a
          href="https://t.me/bnbshield"
          target="_blank"
          style={{ textDecoration: "none" }}
        >
          <Box
            mb={10}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Button
              sx={{
                width: matches ? "200px" : "268px",
                height: matches ? "50px" : "68px",
                borderRadius: "40.5px",
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(16.875px)",
                border: " 1.69px solid #EEBE62",
                color: "#fff",
                textTransform: "capitalize",
                fontSize: matches ? "20px" : "26px",
                fontWeight: 400,
                marginTop: "25px",
              }}
            >
              Join Telegram
            </Button>
          </Box>
        </a>
        <Box
          fontSize={{ xs: "30px", sm: "36px" }}
          fontWeight={700}
          lineHeight="80.86px"
          color="text.primary"
          textAlign="center"
          mt={5}
        >
          CALCULATE PROFIT
        </Box>
        <Box
          bgcolor="rgba(238, 190, 98, 0.12)"
          borderRadius="12px"
          border="2px solid #eebe62"
          sx={{ backdropFilter: "blur(20px)" }}
          width="100%"
          pb={5}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexDirection={matches ? "column" : "row"}
            p={5}
            width="100%"
          >
            <Box
              mr={matches ? 0 : 5}
              display="flex"
              flexDirection="column"
              width={matches ? "100%" : "60%"}
            >
              <Box mb={2}>Deposit Period (days):</Box>
              <IOSSlider
                aria-label="ios slider"
                value={progressValue}
                marks={marks}
                step={1}
                valueLabelDisplay="on"
                max={30}
                min={7}
                onChangeCommitted={(event, value) => {
                  setplanIndex(value - 7);
                  setprogressValue(value);
                }}
              />
            </Box>
            <Box width={matches ? "100%" : "40%"}>
              <Box>Deposit Amount:</Box>
              <Box
                height="60px"
                bgcolor="rgba(238, 190, 98, 0.12)"
                borderRadius="12px"
                border="2px solid #eebe62"
                sx={{ backdropFilter: "blur(33px)" }}
                color="primary.contrastText"
                p={1}
                mt={2}
                display="flex"
                alignItems="center"
              >
                <input
                  style={{
                    color: "#fff",
                    backgroundColor: "transparent",
                    border: "none",
                    // borderColor: "rgba(238, 190, 98, 0.12)",
                    height: "40px",
                    paddingLeft: "5px",
                    width: "80%",
                    marginRight: "10px",
                    outline: "none",
                  }}
                  value={stakingAmount}
                  type="number"
                  onChange={(e) => setstakingAmount(e.target.value)}
                />
                <Box
                  sx={{ cursor: "pointer" }}
                  onClick={() => setstakingAmount(walletBalance)}
                >
                  Max
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            bgcolor="rgba(238, 190, 98, 0.12)"
            borderTop="2px solid #eebe62"
            borderBottom="2px solid #eebe62"
            sx={{ backdropFilter: "blur(20px)" }}
            mt={6}
          >
            <Grid container justifyContent="center">
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={{
                  borderRight: matches ? "none" : "2px solid #eebe62",
                  borderBottom: matches ? "2px solid #eebe62" : "none",
                }}
              >
                <Box p={5}>
                  <Box className={classes.label}>Total Profit:</Box>
                  <Box className={classes.value}>{bonusPercentage / 10}%</Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                sx={{
                  borderRight: matches ? "none" : "2px solid #eebe62",
                  borderBottom: matches ? "2px solid #eebe62" : "none",
                }}
              >
                <Box p={5}>
                  <Box className={classes.label}>Daily ROI:</Box>
                  <Box className={classes.value}>
                    {parseFloat(dailyBonus).toFixed(4)} BNB
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Box p={5}>
                  <Box className={classes.label}>
                    In {progressValue} days you will earn:
                  </Box>
                  <Box className={classes.value}>
                    {parseFloat(bonus).toFixed(4)} BNB
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box display="flex" justifyContent="center" mt={7}>
            <Button
              sx={{
                width: "50%",
                height: "62px",
                borderRadius: "48px",
                border: "2px solid #EEBE62",
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                backdropFilter: "blur(20px)",
                textTransform: "capitalize",
                color: "#FDFCFC",
                fontSize: matches ? "20px" : "24px",
                fontWeight: 700,
              }}
              onClick={() => stakeHadler()}
            >
              Invest
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default CalculateProfit;
